import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback
} from "reactstrap";
import { isLink } from "../../Utils/LinkUtils";
import { toast } from "react-toastify";

const SearchComponent = ({ show, handleClose, onSave, mode, searchData, isSaved }) => {
  const [searchName, setSearchName] = useState("");
  const [comment, setComment] = useState("");
  const [link, setLink] = useState("");
  const [touched, setTouched] = useState(false);

  const isNameValid = searchName.trim().length >= 1;
  const showError = touched && !isNameValid;

  // Populate the fields in "edit" mode when modal is shown
  useEffect(() => {
    if (mode === "edit" && searchData) {
      setSearchName(searchData.name || "");
      setComment(searchData.comments || "");
      setLink(searchData.link || "");
    }
  }, [mode, searchData, show]);

  // Reset the fields on close without saving
  useEffect(() => {
    if (!show) {
      setSearchName("");
      setComment("");
      setLink("");
      setTouched(false);
    }
  }, [show]);

  // Handle reload after save
  useEffect(() => {
    if (isSaved) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [isSaved]);

  // Handle navigate to the link
  const handleNavigate = () => {
    const isValidLink = isLink(link.trim())
    if (isValidLink) {
      window.open(link, '_blank');
    } else {
      toast.error("Please enter the valid link");
    }
  };

  // Handle the save action
  const handleSave = () => {
    setTouched(true);
    
    if (isNameValid) {
      onSave({ searchName, comment, link });
    }
  };

  return (
    <Modal isOpen={show} toggle={handleClose} size="lg">
      <ModalHeader toggle={handleClose}>
        <span style={{ fontSize: "18px" }}>
          {mode === "edit" ? "Edit Search" : "Save Search"}
        </span>
      </ModalHeader>
      <ModalBody>
        <Form>
          {/* Search Name Field */}
          <FormGroup>
            <Label for="searchName">
              Name of Search <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id="searchName"
              value={searchName}
              invalid={showError}
              onChange={(e) => {
                setSearchName(e.target.value);
                setTouched(true);
              }}
              onBlur={() => setTouched(true)}
              placeholder="Enter search name"
            />
            <FormFeedback>
              Search name is required
            </FormFeedback>
          </FormGroup>

          {/* Comment Field */}
          <FormGroup className="mt-3">
            <Label for="comment">Enter Comment for this Search</Label>
            <Input
              type="textarea"
              id="comment"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Add a comment"
            />
          </FormGroup>

          {/* Link Field */}
          <FormGroup className="mt-3">
            <Label for="link">Enter Links for this Comment</Label>
            <Input
              type="text"
              id="link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="Enter a link"
            />
          </FormGroup>

          {/* Navigate Button */}
          <Button
            color="secondary"
            outline
            className="mt-3"
            onClick={handleNavigate}
          >
            Navigate to Above Link
          </Button>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSave}
          className="create-button"
        >
          {mode === 'edit' ? 'Update' : 'Save'}
        </Button>
        <Button
          color="secondary"
          outline
          onClick={handleClose}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SearchComponent;